__webpack_require__.p = "/loyalty/";